import { HttpClient } from '@angular/common/http';
import { Injectable, Input } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ResponseService } from '../../core/models/response-service.model';

@Injectable({
	providedIn: 'root',
})
export class ForecastService {
	constructor(private http: HttpClient) {}

	// Week -- Real Info
	public listForecastWeek() { 
		const url = `${environment.api}forecast/get_forecast_week`;
		return this.http.get<ResponseService>(url);
	}

	public listForecastWeekSearch(
		firstDate: string,
		lastDate: string,
		selectedCampaign: number,
		selectedTypeCampaign: string,
	) {
		const url = `${environment.api}forecast/get_forecast_week_search?campaingId=${selectedCampaign}&firstdate=${firstDate}&lastdate=${lastDate}&type=${selectedTypeCampaign}`;
		return this.http.get<ResponseService>(url);
	}

	// Week Forecast

	public listForecastWeekE() {
		const url = `${environment.api}forecast/get_forecast_week_e`;
		return this.http.get<ResponseService>(url);
	}

	// Month

	public listForecastMonth() {
		const url = `${environment.api}forecast/get_forecast_month`;
		return this.http.get<ResponseService>(url);
	}

	public listForecastMonthSearch(
		firstDate: string,
		lastDate: string,
		selectedCampaign: number,
		selectedTypeCampaign: string,
	) {
		const url = `${environment.api}forecast/get_forecast_month_search?campaingId=${selectedCampaign}&firstdate=${firstDate}&lastdate=${lastDate}&type=${selectedTypeCampaign}`;
		return this.http.get<ResponseService>(url);
	}

	public listForecastYear() {
		const url = `${environment.api}forecast/get_forecast_year`;
		return this.http.get<ResponseService>(url);
	}

	public listForecastYearSearch(
		selectedCampaign: number,
		selectedTypeCampaign: string,
		selectedPeriod: number,
	) {
		const url = `${environment.api}forecast/get_forecast_year_search?year=${selectedPeriod}&campaingId=${selectedCampaign}&type=${selectedTypeCampaign}`;
		return this.http.get<ResponseService>(url);
	}

	public listCampaigns() {
		const url = `${environment.api}forecast/get_all_campaigns`;
		return this.http.get<ResponseService>(url);
	}
}
